// extracted by mini-css-extract-plugin
export var active = "_42-7";
export var container = "_42-0";
export var evenWidth = "_42-4";
export var large = "_42-5";
export var outlet = "_42-8";
export var slide = "_42-2";
export var small = "_42-6";
export var tab = "_42-3";
export var tabs = "_42-1";